import React, { useState } from "react";
import Card from "../../../components/Card/Card";
import { Modal, SubmitButton, TextComponent } from "../../../components";
import styles from "./salesHistory.module.css";
import { Bar } from "react-chartjs-2";
import CompHeader from "../../../components/header/Header";
import { Drawer, Dropdown, Table } from "antd";
import md1 from "../../../assets/images/staticImages/c1.png";
import m1 from "../../../assets/images/staticImages/md1.png";
import p1 from "../../../assets/images/staticImages/pf2.png";
import p2 from "../../../assets/images/staticImages/pf1.png";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import Switch from "../../../components/Switch/Switch";
import { IoClose } from "react-icons/io5";
import c6 from "../../../assets/images/staticImages/c6.png";
import { SlOptionsVertical } from "react-icons/sl";
import BatteryStatus from "../../../components/battery/Battery";

const dummydata = [
  {
    id: 1,
    key: "01",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    NewOwner: { image: p1, name: "Kathy Pacheco" },
    car: { image: md1, name: "Honda" },
    salesPerson: { image: p2, name: "William Rodriguez" },
    transferdate: "Nov 26, 2024",
  },
  {
    id: 2,
    key: "02",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    NewOwner: { image: p1, name: "Kathy Pacheco" },
    car: { image: md1, name: "Honda" },
    salesPerson: { image: p2, name: "William Rodriguez" },
    transferdate: "Nov 26, 2024",
  },
  {
    id: 3,
    key: "03",
    module: { image: m1, name: "Phoenix Immobilizer N16" },
    NewOwner: { image: p1, name: "Kathy Pacheco" },
    car: { image: md1, name: "Honda" },
    salesPerson: { image: p2, name: "William Rodriguez" },
    transferdate: "Nov 26, 2024",
  },
];

const SalesHistory = () => {
  const { width } = useWindowDimensions();
  const [open, setOpen] = useState(false);
  const [showOwnerModal, setShowOwnerModal] = useState(false);
  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (text) => (
        <div>
          <TextComponent text={text} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      render: (item) => (
        <div className={styles.module}>
          <img src={item?.image} className={styles.moduleImg} />
          <TextComponent text={item?.name} className={styles.moduletext} />
        </div>
      ),
    },
    {
      title: "Make",
      dataIndex: "car",
      key: "car",
      render: (item) => (
        <div className={styles.module}>
          <img src={item?.image} className={styles.moduleImg} />
          <TextComponent text={item?.name} className={styles.moduletext} />
        </div>
      ),
    },
    {
      title: "New Owner",
      dataIndex: "NewOwner",
      key: "NewOwner",
      render: (item) => (
        <div
          className={styles.module}
          onClick={(e) => {
            e.stopPropagation();
            setShowOwnerModal(true);
          }}
        >
          <img src={item?.image} className={styles.personImg} />
          <TextComponent text={item?.name} className={styles.pText} />
        </div>
      ),
    },

    {
      title: "Sales Person",
      dataIndex: "salesPerson",
      key: "salesPerson",
      render: (item) => (
        <div className={styles.module}>
          <img src={item?.image} className={styles.personImg} />
          <TextComponent text={item?.name} className={styles.pText} />
        </div>
      ),
    },

    {
      title: "Transfer Date",
      dataIndex: "transferdate",
      key: "transferdate",
      render: (item) => (
        <div className={styles.module}>
          <TextComponent text={item} />
        </div>
      ),
    },
  ];

  return (
    <div className={styles.main}>
      <CompHeader
        mainHeader={styles.mainHeader}
        // onBackClick={() => setCollapsed(!collapsed)}
        // collapsed={collapsed}
        // title={checkRouteName(location.pathname?.substring(1))}
      />
      <Card className={styles.orderMain}>
        <div className={styles.orderMainCont}>
          <TextComponent text="Sales overview" className={styles.headerHead} />
          {/* <TextComponent text="See All" className={styles.seeAll} /> */}
          <SubmitButton title={"Sales Reports"} btnClass={styles.btn} />
        </div>
        <Bar
          height={80}
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: "top",
              },
              title: {
                align: "start",
                display: true,
                text: `132`,
                color: "#ED1C24",
                font: { size: 30, family: "Urbanist" },
              },

              subtitle: {
                align: "start",
                display: true,
                text: "Units",
                color: "#ED1C24",
                font: { size: 18, family: "Urbanist", weight: "bold" },
              },
            },
          }}
          data={{
            datasets: [
              {
                label: "Sales overview",
                data: [
                  10, 20, 30, 40, 50, 20, 10, 20, 30, 40, 50, 20, 10, 20, 30,
                  40, 50, 20, 10,
                ],
                backgroundColor: "#0050A8",
              },
            ],
            labels: [
              "",
              "",
              "",
              "q1",
              "",
              "",
              "",
              "q2",
              "",
              "",
              "",
              "q3",
              "",
              "",
              "",
              "q4",
            ],
          }}
        />
      </Card>

      <Card className={styles.orderMain}>
        <div className={styles.orderMainCont}>
          <TextComponent text="History" className={styles.historyHead} />
        </div>
        <Table
          //   title={}
          scroll={{ x: true }}
          bordered={false}
          pagination={false}
          columns={columns}
          dataSource={dummydata}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => {
                //   setDetails(record);
                setOpen(true);
              },
              style: { cursor: "pointer" },
            };
          }}
        />
      </Card>
      <Drawer
        width={width < 550 ? "100%" : 600}
        headerStyle={{ display: "none" }}
        onClose={() => {
          setOpen(false);
          // setDetails([]);
        }}
        open={open}
      >
        {/* <div className={styles.drawerImgDiv}> */}
        {/* <img src={c6} className={styles.drawerImg} /> */}
        <div
          className={styles.crossIconDiv}
          onClick={() => {
            setOpen(false);
            // setDetails([]);
          }}
        >
          <IoClose />
          {/* </div> */}
        </div>
        <div className={styles.rightCol}>
          <Card>
            <img src={c6} alt="" className={styles.slectedImg} />
            <div className={styles.leftHeader}>
              <div>
                <TextComponent
                  text={"Honda Accord"}
                  className={styles.heading}
                />
                <TextComponent
                  text={"License Plate: ABC1234"}
                  className={styles.carDescText}
                />
                <TextComponent
                  text={"VIN: 4T1B11HK6MU123456"}
                  className={styles.carDescText}
                />
                <TextComponent text={"2016"} className={styles.carDescText} />
                <TextComponent
                  text={"Location: Lot A, Row 5"}
                  className={styles.carDescText}
                />
              </div>
              <div>
                {/* <Dropdown
                  trigger={"click"}
                  menu={
                    {
                      // items: items2,
                    }
                  }
                  placement="bottomRight"
                  arrow={{
                    pointAtCenter: true,
                  }}
                >
                  <button className={styles.menubtn}>
                    <SlOptionsVertical
                      size={20}
                      color="var(--light-text)"
                      cursor={"pointer"}
                    />
                  </button>
                </Dropdown> */}
              </div>
            </div>
          </Card>

          <Card className={styles.card}>
            <div className={styles.leftHeader}>
              <div>
                <TextComponent
                  text={"Phoenix Immobilizer"}
                  className={styles.heading}
                />
                <TextComponent
                  text={"Connected via LoRaWAN"}
                  className={styles.carDescText}
                />
                <TextComponent
                  text={"VIN: 4T1B11HK6MU123456"}
                  className={styles.carDescText}
                />

                <BatteryStatus percentage={85} />
                <div className={styles.scheduleLeftCont}>
                  <Switch
                    isChecked={true}
                    size="small"
                    // style={
                    //   item.isImobilized
                    //     ? { backgroundColor: "var(--primary-color)" }
                    //     : { backgroundColor: "var(--green-color)" }
                    // }
                    // onChange={() => {}}
                    disabled
                  />
                  <TextComponent text={"Immobilized"} className={styles.text} />
                </div>
              </div>
              <div>
                {/* <Dropdown
                  trigger={"click"}
                  menu={
                    {
                      // items: items1,
                    }
                  }
                  placement="bottomRight"
                  arrow={{
                    pointAtCenter: true,
                  }}
                >
                  <button className={styles.menubtn}>
                    <SlOptionsVertical
                      size={20}
                      color="var(--light-text)"
                      cursor={"pointer"}
                    />
                  </button>
                </Dropdown> */}
              </div>
            </div>
          </Card>
          <Card className={styles.card}>
            <TextComponent text={"Access details"} className={styles.heading} />
            <div className={styles.leftHeader}>
              <div>
                <TextComponent
                  text={"Owner: James Hall"}
                  className={styles.carDescText}
                />
              </div>
              <div>
                <TextComponent
                  text={"Ownership Transferred"}
                  className={styles.ownerText}
                />
              </div>
            </div>
          </Card>
        </div>
      </Drawer>
      <Modal
        open={showOwnerModal}
        onCancel={() => setShowOwnerModal(false)}
        icon={
          <img
            src={p1}
            className={styles.personImg}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        }
        title={"Kathy Pacheco"}
        width={"500px"}
        buttonTitle={"Go Back"}
        onBtnPress={() => {
          setShowOwnerModal(false);
        }}
        text={"(917) 339-6416"}
        headingClass={styles.modalHeading}
      >
        <TextComponent
          text={"Kathy.Pacheco@gmail.coms"}
          className={styles.carDescText}
        />
      </Modal>
    </div>
  );
};

export default SalesHistory;
